import {
  Button,
  Col,
  Divider,
  Pagination,
  Row,
  Select,
  Table,
  Tag,
} from "antd";
import { COLORS } from "../constants/Colors";
import Typography from "./Typography";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import React, { useState } from "react";
import ShipmentDetailModal from "./ShipmentDetailModal";
import _ from "lodash";
import moment from "moment/moment";
import { FormattedMessage, useIntl } from "react-intl";
import { SearchOutlined } from "@ant-design/icons";
import exportimg from "../assets/export.svg";
import "./style/checking.css";
import CustomTable from "./TableComponent";

const ParkingList = (props) => {
  const {
    trackingDetail,
    shipmentData,
    total,
    handleChange,
    setEvent,
    handleChangePage,
    isDesktop,
    queueList,
    searchTable,
    handleChangePageRes,
    handleChangeSize,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [detailModal, setDetailModal] = useState([]);
  const [fromTracking, setFromTacking] = useState(true);
  const textTitle = isDesktop ? "13px" : "13px";
  const intl = useIntl();
  const lang = localStorage.getItem("lang");

  const handleClickOpenModal = (value) => {
    setDetailModal(value);
    setIsOpen(true);
    setFromTacking(true);
  };

  const columns = [
    {
      title: (
        <Typography
          className="pl-1"
          isBold
          color={COLORS.Dark}
          size={textTitle}
        >
          <FormattedMessage
            id="HomeParkingNo"
            defaultMessage="ช่องจอด เลขตู้"
          />
        </Typography>
      ),
      dataIndex: "assetDetail.joinNameSerial",
      key: "assetDetail.joinNameSerial",
      width: isDesktop ? 150 : 180,
      sorter: true,
      render: (text, record, index) => (
        <div className="pl-1">{_.get(record, "assetDetail.joinNameSerial")}</div>
      ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="CheckParkingStartDate"
            defaultMessage="วัน/เวลาเข้า"
          />
        </Typography>
      ),
      dataIndex: "assetDetail.startTime",
      key: "assetDetail.startTime",
      align: "left",
      sorter: true,
      width: isDesktop ? 100 : 150,
      render: (text, record, index) => (
        <div className="pl-1">
          {_.get(record, "assetDetail.startTime")
            ? moment(
                _.get(record, "assetDetail.startTime"),
                "DD-MM-YYYY HH:mm"
              ).format("DD/MM/YYYY HH:mm")
            : "-"}
        </div>
      ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="CheckParkingEndDate"
            defaultMessage="วัน/เวลาออก"
          />
        </Typography>
      ),
      dataIndex: "assetDetail.endTime",
      key: "assetDetail.endTime",
      align: "left",
      sorter: true,
      width: isDesktop ? 100 : 150,
      render: (text, record, index) => (
        <div className="pl-1">
          {_.get(record, "assetDetail.endTime")
            ? moment(
                _.get(record, "assetDetail.endTime"),
                "DD-MM-YYYY HH:mm"
              ).format("DD/MM/YYYY HH:mm")
            : "-"}
        </div>
      ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="CheckParkingQueueDone"
            defaultMessage="คิวที่ส่งแล้ว"
          />
        </Typography>
      ),
      dataIndex: "queueDone",
      key: "queueDone",
      align: "left",
      sorter: true,
      width: isDesktop ? 100 : 120,
      // render: (text, record, index) => (
      //   <div className="pl-1">{_.get(record, "assetDetail.queDone")}</div>
      // ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="HomeParkingQueueWaiting"
            defaultMessage="คิวที่รอส่ง"
          />
        </Typography>
      ),
      dataIndex: "queueLeft",
      key: "queueLeft",
      align: "left",
      sorter: true,
      width: isDesktop ? 100 : 120,
      // render: (text, record, index) => (
      //   <div className="pl-1">{_.get(record, "assetDetail.queLeft")}</div>
      // ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage id="HomeParkingStatus" defaultMessage="สถานะ" />
        </Typography>
      ),
      dataIndex: "status",
      key: "status",
      width: isDesktop ? 150 : 100,
      render: (text, record, index) => (
        <Tag
          className="tag-queue-right"
          color={_.get(record, "assetDetail.status.detail.color")}
        >
          <Typography
            className={isDesktop ? "px-2 py-1" : "px-0 py-1"}
            isBold
            color={COLORS.White}
            size={isDesktop ? "13px" : "12px"}
            textAlign={"center"}
          >
            {lang === "EN"
              ? _.get(record, "assetDetail.status.detail.EN")
              : _.get(record, "assetDetail.status.detail.TH")}
          </Typography>
        </Tag>
      ),
    },
  ];

  const showTotal = () => {
    return (
      <span style={{ fontSize: "13px" }}>
        <FormattedMessage id="lblRowPerPage" defaultMessage="Rows per page: " />
      </span>
    );
  };
  const perth =
    "/" +
    " " +
    intl.formatMessage({
      id: "lblPerPage",
      defaultMessage: "page",
    });

  const paginationLocale = {
    items_per_page: perth,
  };

  const PageSizeSelector = ({
    onPageSizeChange,
    pageSizeOptions,
    defaultPageSize,
  }) => (
    <Select
      defaultValue={defaultPageSize}
      onChange={onPageSizeChange}
      options={pageSizeOptions.map((size) => ({
        value: size,
        label: `${size} / page`,
      }))}
      style={{ marginRight: "10px", width: "100%" }}
    />
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px",
        backgroundColor: "white",
        width: "100%",
        height: isDesktop ? "calc(100vh - 278px)" : undefined,
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <div className="py-3 px-4 d-flex align-items-center justify-content-between">
          <Typography isBold color={COLORS.Dark}>
            <FormattedMessage
              id="menuChecking"
              defaultMessage="ตรวจสอบสถานะช่องจอด"
            />
          </Typography>
        </div>
        <Divider className="m-0" />
        <div
          className="p-4"
          style={{
            height: isDesktop ? "calc(100vh - 430px)" : undefined,
            overflowY: isDesktop ? "auto" : undefined,
          }}
        >
          <Table
          className="custom-table"
            columns={columns}
            dataSource={queueList}
            pagination={false}
            onChange={handleChange}
            scroll={{ x: _.sumBy(columns, "width") }}
          />
          {/* <CustomTable column={columns} data={queueList} total={total} scroll={{ x: _.sumBy(columns, "width") }} pagination={true}  />*/}
        </div>
        {isDesktop ? (
          <div className="d-flex justify-content-between align-items-center pl-4">
            <div>
              <span style={{ fontSize: "13px" }}>
                <FormattedMessage id="lblTotal" defaultMessage="Total" />
                {` ${total || 0} `}
                <FormattedMessage id="lblitems" defaultMessage="items" />
              </span>
            </div>
            <div
              className="custom-pagination"
              style={{ textAlign: "right", padding: "16px 24px" }}
            >
              <Pagination
                defaultCurrent={1}
                total={total}
                onChange={handleChangePage}
                showSizeChanger={true}
                showTotal={showTotal}
                pageSizeOptions={["10", "20", "50", "100"]}
                defaultPageSize={"10"}
                current={_.get(searchTable, "page")}
                locale={paginationLocale}
                pageSize={_.get(searchTable, "size")}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-between align-items-center pl-4">
              <div>
                <span style={{ fontSize: "13px" }}>
                  <FormattedMessage id="lblTotal" defaultMessage="Total" />
                  {` ${total || 0} `}
                  <FormattedMessage id="lblitems" defaultMessage="items" />
                </span>
              </div>
              <div
                className="custom-pagination"
                style={{ textAlign: "right", padding: "16px 24px" }}
              >
                <PageSizeSelector
                  defaultPageSize={_.get(searchTable, "size")}
                  pageSizeOptions={["10", "20", "50", "100"]}
                  onPageSizeChange={handleChangeSize}
                />
              </div>
            </div>
            <div style={{ textAlign: "center", padding: "16px 24px" }}>
              <Pagination
                defaultCurrent={1}
                total={total}
                onChange={handleChangePageRes}
                showSizeChanger={true}
                // showTotal={showTotal}
                pageSizeOptions={["10", "20", "50", "100"]}
                defaultPageSize={10}
                current={_.get(searchTable, "page")}
                locale={paginationLocale}
                pageSize={_.get(searchTable, "size")}
              />
            </div>
          </div>
        )}
      </div>

      <ShipmentDetailModal
        info={detailModal}
        isOpen={isOpen}
        onCancle={() => {
          setIsOpen(false);
          setFromTacking(false);
        }}
        onClickPrint={() => {}}
        onCancleShipment={() => {}}
        trackingDetail={trackingDetail}
        isPreview
        setEvent={setEvent}
        setIsOpen={setIsOpen}
        fromTracking={fromTracking}
        shipmentData={shipmentData}
        setDetailModal={setDetailModal}
      />
    </div>
  );
};

export default ParkingList;
